<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        class="ml-2 d-print-none"
        color="primary"
        @click="OpenDialog"
        v-bind="attrs"
        :loading="isloading"
        icon
      >
        <v-icon>fas fa-reply</v-icon>
      </v-btn>
    </template>
    <v-card>
      <!-- <h1>Undo Option</h1> -->
      <v-card-title class="error white--text" primary-title>
        Return Option
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" icon color="white">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div id="PrintPage" class="myContainer">
          <div class="myContainer printHearder">
            <div class="Headerinfo">
              <!-- <h3>{{ UsersToken.UserBranch }}</h3>
              <h5>{{ UsersToken.phone }}</h5>
              <h5>{{ `${UsersToken.country}-${UsersToken.City}` }}</h5> -->
              <div class="">
                <h3>Order: {{ SaleOrder.Details }}</h3>
                <h3>Date: {{ SaleOrder.date }}</h3>
              </div>
            </div>
            <div class="Headerinfo">
              <div class="">
                <h3>Client: {{ SaleOrder.Name }}</h3>
                <h3>Phone: {{ SaleOrder.phone }}</h3>
              </div>
            </div>
          </div>
          <div class="myContainer printHearder2">
            <div class="Headerinfo">
              <div class="clientInf">
                <div class="myTitle">TOTAL:</div>
                <div class="myContent">
                  {{ totalPrice.toLocaleString() }}
                  <span>{{ UsersToken.CashBase | MoneySigns }}</span>
                </div>
              </div>

              <div class="clientInf">
                <div class="myTitle">Discount:</div>
                <div class="myContent">
                  {{
                    client.Discount
                      ? client.Discount.toLocaleString()
                      : client.Discount
                  }}
                  <span>{{ UsersToken.CashBase | MoneySigns }}</span>
                </div>
              </div>
              <div class="clientInf">
                <div class="myTitle">PAID:</div>
                <div class="myContent">
                  {{
                    client.Amount
                      ? client.Amount.toLocaleString()
                      : client.Amount
                  }}
                  <span>{{ UsersToken.CashBase | MoneySigns }}</span>
                </div>
              </div>
              <div class="clientInf">
                <div class="myTitle">BALANCE:</div>
                <div class="myContent">
                  {{
                    client.Remain
                      ? client.Remain.toLocaleString()
                      : client.Remain
                  }}
                  <span>{{ UsersToken.CashBase | MoneySigns }}</span>
                </div>
              </div>
            </div>
          </div>
          <BasePureTable
            key="PrintTable"
            :myStyle="TableStyle"
            :headers="headers"
            :items="items"
          >
            <template #[`coll.QTY`]="{row}">
              {{ row | SellTypeQty }}
            </template>
            <template #[`coll.R_QTY`]="{row}">
              <returnQTY
                :key="row._id + 'Rtn'"
                @returnQty="row.RQTY = $event"
                :EditeItems="row"
              >
                {{ row | ReturnQtyFormt }}</returnQTY
              >
            </template>

            <template #[`coll.Price`]="{row}">
              {{ row | SellTypePrice }}
            </template>
            <template #[`coll.R_Price`]="{row}">
              {{ (row.RQTY * row.price).toLocaleString() }}
            </template>
            <template #tableFoot>
              <td></td>
              <td>{{ totalQty.toLocaleString() + " PCS" }}</td>
              <td>
                {{ totalPrice.toLocaleString() }}
                <span>{{ UsersToken.CashBase | MoneySigns }}</span>
              </td>
              <td></td>
              <td></td>
            </template>
          </BasePureTable>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <p class="error--text">{{ ErrMsg }}</p>
        <v-spacer></v-spacer>
        <v-btn
          :loading="isloading"
          @click="onConfirmReturn"
          v-if="CanReturn"
          color="warning"
          dark
          >Confirm Return
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import returnQTY from "../returnQTY.vue";
export default {
  components: { returnQTY },
  props: {
    SaleOrder: [Object],
  },
  data() {
    return {
      ErrMsg: "",
      PrintUrl: "/Reports/sales/print",
      dialog: false,
      isloading: false,
      items: [],
      Entry: [],
      headers: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
          class: "green darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "green darken-3 white--text",
        },

        {
          text: "Price",
          value: "price",
          class: "green darken-3 white--text",
        },
        {
          text: "R_QTY",
          value: "RQTY",
          class: "green darken-3 white--text",
        },
        {
          text: "R_Price",
          value: "RPrice",
          class: "green darken-3 white--text",
        },
      ],
      TableStyle: {
        tBodyStyle: {
          borderBottom: "10px solid black",
        },
        headStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
          black: true,
        },
        bodyStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
        },
      },
    };
  },
  filters: {
    SellTypePrice(item) {
      // if (item.SellType == "retail")
      //   return (item.price / item.UnitQty).toFixed(1).toLocaleString();
      return item.price.toLocaleString();
    },
    SellTypeQty(row) {
      let qty = Math.abs(row.qty);
      const PCSQTY = (qty * row.UnitQty) % row.UnitQty;
      const BOXQTY = parseInt(qty);
      let FormatQTY = `0-${row.UnitType} `;
      if (BOXQTY > 0) FormatQTY = `${BOXQTY}-${row.UnitType} `;
      if (PCSQTY > 0) FormatQTY += `${PCSQTY}-PCS`;
      FormatQTY += ` =>(${qty * row.UnitQty} PCS)`;
      return FormatQTY;
      // if (row.SellType == "retail")
      //   return `${(Math.abs(row.qty) * row.UnitQty).toLocaleString()} PCS`;
      // return `${Math.abs(row.qty).toLocaleString()} ${row.UnitType}`;
    },
    ReturnQtyFormt(row) {
      // if (row.SellType == "retail")
      //   return `${(Math.abs(row.qty) * row.UnitQty).toLocaleString()} PCS`;
      // return `${Math.abs(row.qty).toLocaleString()} ${row.UnitType}`;
      let { RQTY, UnitQty, UnitType } = row;
      let CRT = parseInt(RQTY);
      let PCS = (RQTY * UnitQty) % UnitQty;
      let FormString = "";
      if (RQTY == 0) return "0 Return";

      if (CRT > 0) FormString = `${CRT}-${UnitType} `;
      if (PCS > 0) FormString += `${PCS}-PCS`;
      return FormString;
    },
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    CanReturn() {
      return this.items.some(item => item.RQTY > 0);
    },
    PaidAmount() {
      // return this.SaleOrder.Amount - this.client.Discount - this.client.Remain;
      let Paid =
        this.totalPrice - this.client.Discount - Math.round(this.client.Remain);
      console.log(parseFloat(Paid));
      return Paid;
    },
    client() {
      if (!this.Entry.length) return { Amount: 0, Discount: 0, Remain: 0 };
      return {
        Amount: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (
            AccountName === "Mobel" ||
            AccountName === "Cash" ||
            AccountName === "Main Bank"
          )
            return (t += Amount);
          return t;
        }, 0),
        Discount: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (AccountName === "Sales Discount") return (t += Amount);
          return t;
        }, 0),
        Remain: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (AccountName === "Sales Receivable") return (t += Amount);
          return t;
        }, 0),
      };
    },

    totalPrice() {
      return this.items.reduce((t, { price, qty, SellType, UnitQty }) => {
        qty = Math.abs(qty);
        if (SellType == "retail") qty = UnitQty * qty;
        // console.log();
        return (t += parseFloat((price * qty).toFixed(1)));
      }, 0);
    },
    totalQty() {
      return this.items.reduce((t, { qty, UnitQty }) => {
        qty = Math.abs(qty * UnitQty);
        // if (SellType == "retail") qty = qty * UnitQty;
        return (t += qty);
      }, 0);
    },
  },
  methods: {
    onConfirmReturn() {
      this.isloading = true;
      // console.log(this.Entry);
      this.ErrMsg = "";
      let ReturnObj = {
        date: this.Current().date,
        items: this.items.filter(item => item.RQTY > 0),
        Payment: { ...this.client, Paid: this.client.Amount },
        OrderCode: this.SaleOrder.Details,
        Description: this.SaleOrder.Description,
        Ref: this.SaleOrder.Ref,
      };
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/Reports/sales/return",
          data: ReturnObj,
        })
        .then(() => {
          // console.log(val);
          this.isloading = false;
          this.dialog = false;
        })
        .catch(err => {
          this.isloading = false;
          // console.log(err.response.data);
          this.ErrMsg = err && err.response && err.response.data;
        });
    },
    OpenDialog() {
      this.isloading = true;
      this.items = [];
      this.Entry = [];
      this.isloading = true;
      this.GetReq()
        .then(val => {
          // const { Entry, items } = val.data;
          this.items = val.data.items.map(itm => ({ ...itm, RQTY: 0 }));
          this.Entry = val.data.Entry;
          // console.log(this.items);

          this.dialog = true;
          this.isloading = false;
          // console.log(this.Entry);
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    GetReq(query = null) {
      if (!query) {
        query = {
          OrderCode: this.SaleOrder.Details,
          Description: this.SaleOrder.Description,
          Ref: this.SaleOrder.Ref,
        };
      }
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.PrintUrl,
        query,
      });
    },
    onReturn(item, v) {
      // console.log("hellwo");
      console.log(v);
      item.RQTY = v;
      // console.log(item);
    },
  },
  // mounted() {
  //   // console.log("hellow");
  // },
};
</script>
<style scoped>
#PrintPage {
  padding: 10px 15px;
  height: 100%;
  flex-direction: column;
  background-color: white;
  /* font-family: "Courier New", Courier, monospace; */
}
.myContainer {
  display: flex;
}
.printHearder {
  /* flex-direction: ; */
  /* margin-top: 10px; */
  background-color: black;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 90%;
  align-self: center;
}
.printHearder .Headerinfo {
  display: flex;
  flex-direction: row;
  justify-items: end;
  /* width: 100%; */
  padding: 5px;
  margin-bottom: 5px;
  color: white;
  /* max-width: 40%; */
  /* background-color: blue; */
  align-items: center;
  line-height: 20px;
  /* flex-grow: 2; */
}
.printHearder2 {
  margin-top: 5px;
  background-color: black;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  /* flex-wrap: wrap; */
  justify-content: space-around;
  width: 90%;
  align-self: center;
}
.printHearder2 .Headerinfo {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom: 5px;
  color: white;
  justify-content: center;
  max-width: 40%;
  padding-right: 10px;
  padding-left: 10px;
}
.clientInf {
  display: flex;
  flex-direction: row;
}
.clientInf .myTitle {
  /* font-weight: bold; */
  padding-right: 10px;
  flex-wrap: nowrap;
}
.clientInf .myContent {
  flex-wrap: wrap;
  font-weight: lighter;
  text-align: center;
}

.Headerinfo h3,
.Headerinfo h5 {
  line-height: 0.5cm;
  font-weight: bold;
}

.titleBar {
  display: flex;
  flex-direction: row-reverse;
  background-color: rgb(3, 3, 129);
  height: 40px;
  align-items: center;
  padding-right: 15px;
  width: 90%;
  align-self: center;
  margin-bottom: 5px;
}
</style>
